import img1 from '../img/ServicesDataImg/1.webp'
import img2 from '../img/ServicesDataImg/2.jpg'
import img3 from '../img/ServicesDataImg/3.jpg'
import img4 from '../img/ServicesDataImg/4.jpg'



export const ServicesData =[
    {
        id:'SId1',
        title:'Design',
        img1:img1,
        img2:img2,
        img3:img3,
        img4:img4,
    },
    {
        id:'SId2',
        title:'Developper',
        img1:img1,
        img2:img3,
        img3:img4,
        img4:img2,
    },
    {
        id:'SId3',
        title:'Videography',
        img1:img4,
        img2:img2,
        img3:img1,
        img4:img3,
    },
    

]